import React from "react";
import { HelperLink, HelperIcon, HelperTitle, HelperWrapper, UploadsIndicatorLink, UploadsIndicatorWrapper } from "./index.styled";
import { VipPageView } from ".";

export interface PageHelperProps {
    pageState?: VipPageView;
    setUploadsIndicator?: (indicator: 'my_uploads' | 'sent_from_coach') => void;
    onHelperClick?: () => void;
}


const PageHelper: React.FC<PageHelperProps> = ({ pageState, setUploadsIndicator, onHelperClick }) => {
    const uploadsIndicator = (
        <UploadsIndicatorWrapper>
            <UploadsIndicatorLink onClick={() => setUploadsIndicator && setUploadsIndicator('my_uploads')}>MY UPLOADS</UploadsIndicatorLink>
            <UploadsIndicatorLink onClick={() => setUploadsIndicator && setUploadsIndicator('sent_from_coach')}>SENT FROM COACH</UploadsIndicatorLink>
        </UploadsIndicatorWrapper>
    );
    return (
        <HelperWrapper $pageState={pageState as VipPageView}>
            {pageState === 'init' ? uploadsIndicator : pageState === 'onboarding' ? <HelperTitle $pageState={pageState as VipPageView}>GETTING STARTED</HelperTitle> : <HelperTitle $pageState={pageState as VipPageView}>MESSAGES</HelperTitle>}
            {(pageState === 'chat' || pageState === 'onboarding') && (
                <HelperLink $pageState={pageState as VipPageView} onClick={onHelperClick}>
                    Need Help Recording Your Swing?
                    <HelperIcon src="https://members.performancegolf.com/wp-content/themes/pgm/dist/images/icons/help-gray.svg" alt="" />
                </HelperLink>
            )}
        </HelperWrapper>
    );
}

export default PageHelper;